import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useLazyReducer } from '@/domains/core/applicationState/hooks/useLazyReducer';
import { useLazySaga } from '@/domains/core/applicationState/hooks/useLazySaga';
import { isB2B } from '@/domains/core/settings/utils';

import { selectProductRecommendationConfigs } from '../../../selectors/productRecommendation';
import { PRODUCT_RECOMMENDATION } from '../constants';
import { fetchRecommendation } from '../ProductRecommendation.actions';

const rootRecommendationSaga = () =>
  import(
    '@/domains/productDiscovery/Recommendation/modules/ProductRecommendation/ProductRecommendation.saga'
  ).then((mod) => mod.default);

const recommendationReducer = () =>
  import(
    '@/domains/productDiscovery/Recommendation/modules/ProductRecommendation/ProductRecommendation.reducer'
  ).then((mod) => mod.default);

export const useRecommendationFromConfig = (hasBeenDisplayed = false) => {
  const dispatch = useDispatch();
  const config = useSelector(selectProductRecommendationConfigs);
  // Filter out SimilarityML_v2 engine on B2C, because we already fetched all products information on server side for this playlist
  const filteredConfig = isB2B()
    ? config
    : config?.filter((item) => item?.engineName !== 'SimilarityML_v2');
  const { sagaInjected } = useLazySaga(
    PRODUCT_RECOMMENDATION,
    rootRecommendationSaga,
    {
      condition: hasBeenDisplayed,
    },
  );
  const { reducerInjected } = useLazyReducer(
    `productDiscovery.${PRODUCT_RECOMMENDATION}`,
    recommendationReducer,
    { condition: hasBeenDisplayed },
  );

  useEffect(() => {
    if (
      hasBeenDisplayed &&
      reducerInjected &&
      sagaInjected &&
      filteredConfig?.length
    ) {
      dispatch(fetchRecommendation(filteredConfig));
    }
  }, [
    hasBeenDisplayed,
    dispatch,
    filteredConfig,
    sagaInjected,
    reducerInjected,
  ]);
};
